var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.queryOption.action==='error'),expression:"queryOption.action==='error'"}]},[_vm._v(" error Page ")])])}
var staticRenderFns = []

export { render, staticRenderFns }